<template>
  <el-dialog
    :title="$t('328')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="400px"
    class="setting-manger-dialog"
  >
    <p>{{ $t('329') }}：</p>
    <el-select
      v-model="staff"
      filterable
      remote
      reserve-keyword
      clearable
      value-key="staff_id"
      :placeholder="$t('177')"
      :remote-method="supRemoteMethod"
      class="manger-select-custom"
    >
      <el-option v-for="item in staffList" :key="item.staff_id" :label="item.staff_name" :value="item"></el-option>
    </el-select>
    <!-- 验证码 -->
    <el-input :placeholder="$t('243')" v-model="staff.verify_code" class="code">
      <template slot="append">
        <el-button :disabled="disabled" @click="gandleGetShortCode">
          {{ qrcodeText }}
        </el-button>
      </template>
    </el-input>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="transfer">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { searchStaffFn } from 'api/org/per'
import { getShortCode, getCompanyInfo } from 'api/common'
import { transfer } from 'api/settings'

import { getUserInfo } from 'api/login'
import s from 'storejs'
export default {
  data() {
    return {
      value: '',
      visible: false,
      loading: true,
      gridData: [],
      options: [],
      mobile: 0,
      input2: '',
      // 员工列表
      staffList: [],
      // 当前选择员工
      staff: '',
      // 验证码text
      qrcodeText: this.$t('822'),
      disabled: false
    }
  },
  methods: {
    init(s, p) {
      this.visible = s
      this.mobile = p
    },
    supRemoteMethod(query) {
      if (query !== '') {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(res => {
            if (res && res.code === 1) {
              this.staffList = res.data.map(v => ({
                staff_name: v.staff_name,
                staff_id: v.staff_id,
                mobile: v.mobile
              }))
            }
          })
        }, 300)
      } else {
        this.staffList = []
      }
    },
    // 获取验证码
    gandleGetShortCode() {
      if (this.staff.staff_id && this.mobile) {
        const msg = {
          calling_code: s.get('userInfo').cc,
          mobile: this.mobile
        }
        getShortCode(msg).then(res => {
          this.$s.set('timer', new Date().getTime())
          this.qrcodeTime()
        })
      } else {
        this.$notify({
          title: this.$t('229'),
          message: this.$t('823'),
          type: 'warning'
        })
      }
    },
    // 倒计时
    qrcodeTime() {
      // const self = this;
      const play = setInterval(() => {
        const current = new Date().getTime()
        const last = this.$s.get('timer')
        const haveTime = 60 - (current - last) / 1000
        if (haveTime > 0) {
          this.qrcodeText = `${Math.floor(haveTime)}s`
          this.disabled = true
          return false
        }
        clearInterval(play)
        this.disabled = false
        this.qrcodeText = this.$t('822')
      }, 1000)
    },
    // 更换请求
    transfer() {
      transfer(this.staff).then(res => {
        this.visible = false
        getCompanyInfo().then(res => {
          s.set('currentCompany', res.data)
          this.$parent.currentCompany = this.$s.get('currentCompany')
        })
        // 获取用户信息
        getUserInfo().then(res => {
          s.set('userInfo', res.data.user_info)
        })
      })
    }
  }
}
</script>

<style lang="scss">
.setting-manger-dialog {
  .manger-select-custom {
    width: 90%;
    margin-top: 15px;
    .el-input {
      max-width: 100%;
    }
    input {
      max-width: 100%;
      height: 32px;
    }
  }
  .code {
    width: 90%;
    margin-top: 15px;
    max-width: 90%;
    margin-top: 20px;
    input {
      max-width: 100%;
      height: 32px;
    }
  }
  .el-dialog__body {
    min-height: 200px;
  }
}
</style>
>
